var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGifts = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 21.583C21 22.3194 20.4034 22.917 19.667 22.917H11.667C10.9306 22.917 10.334 22.3194 10.334 21.583V15.917H21V21.583ZM18.334 9.08301C19.3464 9.08318 20.167 9.90458 20.167 10.917C20.167 11.152 20.1226 11.3766 20.042 11.583H21C21.7364 11.583 22.334 12.1806 22.334 12.917V13.583C22.334 14.3194 21.7364 14.917 21 14.917H10.334C9.5976 14.917 9 14.3194 9 13.583V12.917C9 12.1806 9.5976 11.583 10.334 11.583H11.292C11.2114 11.3766 11.167 11.152 11.167 10.917C11.167 9.90458 11.9876 9.08318 13 9.08301C14.1195 9.08301 15.1039 9.66415 15.667 10.541C16.2301 9.66415 17.2145 9.08301 18.334 9.08301ZM13 10.083C12.5399 10.0832 12.167 10.4569 12.167 10.917C12.1671 11.1893 12.2979 11.431 12.5 11.583H15.0625C14.7812 10.7127 13.9639 10.083 13 10.083ZM18.334 10.083C17.3701 10.083 16.5528 10.7127 16.2715 11.583H18.834C19.0361 11.431 19.1669 11.1893 19.167 10.917C19.167 10.4569 18.7941 10.0832 18.334 10.083Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGifts);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gifts.bbf987da1221a8cb0ac66376f84a2c62.svg";